<template>
  <tbody>
  <tr class="table-row-style">
    <td v-if="!isUpdateMode">
      <span>{{ prolongedSickLeavePeriod.startDate }}</span>
    </td>
    <td v-else>
      <DateInputField
          class="w-50 d-inline-block" v-model="updateProlongedSickLeaveDates.startDate"
          :overlap-with-other-period="isPeriodOverlapping()"
          labelText="start datum" noLabel/>
    </td>
    <td v-if="!isUpdateMode">
      <span>{{ prolongedSickLeavePeriod.endDate ? prolongedSickLeavePeriod.endDate : " nog niet bekend" }}</span>
    </td>
    <td v-else>
      <DateInputField
          class="w-50 d-inline-block" v-model="updateProlongedSickLeaveDates.endDate"
          :after-date="startDateFormatted()"
          :overlap-with-other-period="isPeriodOverlapping()"
          labelText="eind datum" noLabel/>
    </td>
    <td class="btn-group">
      <button
          v-show="!isUpdateMode"
          class="btn-basic btn-outline-pulse w-auto mr-2" @click="toggleUpdateMode">
        Datums aanpassen
      </button>
      <button
          v-show="!isUpdateMode"
          class="btn-basic btn-danger w-auto mr-2" @click="deleteRow">
        Verwijderen
      </button>
      <button
          v-show="isUpdateMode" :disabled="isPeriodOverlapping() || isUpdateStartBeforeEnd()"
          class="btn-basic btn-fill-pulse mr-2" @click="saveDates">
        Opslaan
      </button>
      <button
          v-show="isUpdateMode"
          class="btn-basic btn-fill-pulse-dark" @click="toggleUpdateMode">
        Annuleren
      </button>
    </td>
  </tr>
  </tbody>
</template>

<script>


import DateInputField from "@/components/inputFields/DateInputField.vue";
import {mapActions} from "vuex";
import {toYearAndMonthAndDay} from "@/util/DateUtil";

export default {
  components: {DateInputField},
  props: ['prolongedSickLeavePeriod', 'prolongedSickLeavePeriodsList'],
  data: () => ({
    isUpdateMode: false,
    updateProlongedSickLeaveDates: {
      startDate: undefined,
      endDate: undefined
    },
  }),
  methods: {
    ...mapActions("administrationUser", ["updateProlongedSickLeaveForSelectedUser", "deleteProlongedSickLeaveForSelectedUser"]),
    toggleUpdateMode() {
      this.isUpdateMode = !this.isUpdateMode;
      this.updateProlongedSickLeaveDates.startDate = this.prolongedSickLeavePeriod.startDate;
      this.updateProlongedSickLeaveDates.endDate = this.prolongedSickLeavePeriod.endDate;
    },
    deleteRow() {
      if (confirm("Weet u zeker dat u deze periode van langdurige ziekte wilt verwijderen?")) {
        this.deleteProlongedSickLeaveForSelectedUser(this.prolongedSickLeavePeriod.id);
      }
    },
    saveDates() {
      const updateProlongedSickLeaveDatesDto = {
        id: this.prolongedSickLeavePeriod.id,
        startDate: this.updateProlongedSickLeaveDates.startDate,
        endDate: this.updateProlongedSickLeaveDates.endDate,
      };
      this.updateProlongedSickLeaveForSelectedUser(updateProlongedSickLeaveDatesDto);
      this.isUpdateMode = !this.isUpdateMode;
    },
    isPeriodOverlapping() {
      for (let period of this.prolongedSickLeavePeriodsList) {
        if (period.id !== this.prolongedSickLeavePeriod.id) {
          if (period.endDate !== null
              && this.doesPeriodsOverlap(period, this.updateProlongedSickLeaveDates))  {
            return true;
          }
          if (period.endDate === null
              && (this.updateProlongedSickLeaveDates.startDate >= period.startDate
                  || this.updateProlongedSickLeaveDates.endDate >= period.startDate)) {
            return true;
          }
        }
      }
      return false;
    },
    doesPeriodsOverlap(period1, period2) {
      let latestStart = period1.startDate > period2.startDate ? period1.startDate : period2.startDate;
      let earliestEnd = period1.endDate < period2.endDate || period2.endDate === null ? period1.endDate : period2.endDate;
      return latestStart <= earliestEnd;
    },
    startDateFormatted() {
      return toYearAndMonthAndDay(this.updateProlongedSickLeaveDates.startDate);
    },
    isUpdateStartBeforeEnd() {
      return this.updateProlongedSickLeaveDates.endDate !== null
          ? this.updateProlongedSickLeaveDates.endDate <= this.updateProlongedSickLeaveDates.startDate
          : false;
    }
  }
};
</script>

<style>

</style>